module.exports = __webpack_public_path__ + "media/images/sub-995ddd6f8841716ef54e8c6d2c0db837.svg";